// 基本的に秒表示は行わない仕様で作成している

export function plainToDateFormat(date: string | undefined | null): string {
  if (date === '' || date === undefined || date === null) return ''
  if (date.length !== 8) {
    console.warn('plainToDateFormat() - invalid parameter', date)
    return ''
  }
  return `${date.substr(0, 4)}/${date.substr(4, 2)}/${date.substr(6, 2)}`
}

export function dateToPlainFormat(date: string | undefined | null): string {
  if (date === '' || date === undefined || date === null) return ''
  if (date.length !== 10) {
    console.warn('dateToPlainFormat() - invalid parameter', date)
    return ''
  }
  return date.replace(/-/g, '')
}

export function plainToDateTimeFormat(date: string | undefined | null): string {
  if (date === '' || date === undefined || date === null) return ''
  if (date.length !== 12) {
    console.warn('plainToDateTimeFormat() - invalid parameter', date)
    return ''
  }
  return `${date.substr(0, 4)}/${date.substr(4, 2)}/${date.substr(
    6,
    2
  )} ${date.substr(8, 2)}:${date.substr(10, 2)}`
}

export function dateTimeToPlainFormat(date: string | undefined | null): string {
  if (date === '' || date === undefined || date === null) return ''
  if (date.length !== 19) {
    console.warn('dateTimeToPlainFormat() - invalid parameter', date)
    return ''
  }
  return date.replace(/[-: ]/g, '').slice(0, 12)
}

// 一度プレーン化してから使用する事、後々メソッド名変更
export function dateTimeToDateFormat(date: string | undefined | null): string {
  if (date === '' || date === undefined || date === null) return ''
  if (date.length !== 12) {
    console.warn('dateTimeToDateFormat() - invalid parameter', date)
    return ''
  }

  return date.slice(0, 8)
}

// 一度プレーン化してから使用する事、後々メソッド名変更
export function dateTimeToTimeFormat(date: string | undefined | null): string {
  if (date === '' || date === undefined || date === null) return ''
  if (date.length !== 12) {
    console.warn('dateTimeToTimeFormat() - invalid parameter', date)
    return ''
  }

  return date.slice(8, 12)
}

// 時分のプレーンを使用、後々メソッド名変更
export function plainToTimeFormat(time: string | undefined | null): string {
  if (time === '' || time === undefined || time === null) return ''
  if (time.length !== 4) {
    console.warn('plainToTimeFormat() - invalid parameter', time)
    return ''
  }

  return `${time.substr(0, 2)}:${time.substr(2, 2)}`
}
